import { render, staticRenderFns } from "./TempCourses.vue?vue&type=template&id=5ca4f695&scoped=true&"
import script from "./TempCourses.vue?vue&type=script&lang=js&"
export * from "./TempCourses.vue?vue&type=script&lang=js&"
import style0 from "./TempCourses.vue?vue&type=style&index=0&id=5ca4f695&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca4f695",
  null
  
)

export default component.exports